import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { money } from "@/lib/money";
import { CompWeeksTable } from "@/components/CompWeeksTable";
import { PageHeader, StatCard } from "./shared";

const hrs = (n) => (Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 1 });

export default function SalesComp() {
  const [weeks, setWeeks] = useState(12);
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/sales/me/dashboard?weeks=${weeks}`).then((r) => setD(r.data)).catch(() => {}); }, [weeks]);
  if (!d) return <div className="text-slate-500">Loading…</div>;
  const rep = d.rep;

  return (
    <div data-testid="sales-comp">
      <PageHeader eyebrow="Compensation" title="My Comp"
        blurb={<>Each week you're paid the greater of your <b>{money(rep.weekly_draw)} draw</b> or <b>approved hours × {money(rep.rate_per_hour)}</b>. Only supervisor-approved hours on projects credited to you count.</>}
        action={
          <div className="inline-flex rounded-md border border-slate-300 bg-white overflow-hidden" data-testid="comp-weeks-picker">
            {[12, 26, 52].map((n) => (
              <button key={n} onClick={() => setWeeks(n)} data-testid={`comp-weeks-${n}`}
                      className={`h-10 px-3 text-sm font-semibold ${weeks === n ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-50"}`}>{n} wks</button>
            ))}
          </div>
        } />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
        <StatCard label="Rate per approved hour" value={money(rep.rate_per_hour)} testId="comp-rate" />
        <StatCard label="Weekly draw" value={money(rep.weekly_draw)} testId="comp-draw" />
        <StatCard label="Break-even" value={`${hrs(rep.break_even_hours)} hrs`} sub="per week" testId="comp-break-even" />
        <StatCard label="YTD pay" value={money(d.ytd.pay)} sub={`${hrs(d.ytd.hours)} hrs · ${d.ytd.weeks_over_break_even} wks over`} tone="emerald" testId="comp-ytd" />
      </div>

      <CompWeeksTable weeks={d.weeks} />
      <p className="text-xs text-slate-500 mt-3">“Pay run” shows when the office has included the week in a pay run. Pending hours become approved once the client supervisor signs off on the timesheet.</p>
    </div>
  );
}
